<template>
    <div class="device-type-manange relative expert-list expert_card_wrap">
        <div>
            <div class="buttons" style="position: static;">
                <el-button @click="addExpert">新增</el-button>
                <!--            <el-button @click="editExpertManual">编辑手册</el-button>-->
                <el-button class="buttons_btn" type="primary" @click="oneReservationDetail({photo_pictures: JSON.stringify(expert_photo)})">专家手册
                </el-button>
                <el-button class="buttons_btn" type="primary" @click="getExpertVisits">出诊时间</el-button>
                <el-button class="buttons_btn" type="primary" @click="exportExpertPdf">导出资料</el-button>
                <el-button class="buttons_btn" type="primary" @click="exportExpertExcel">导出报表</el-button>

            </div>
            <div class="buttons"  style="position: static;" v-if="export_excel || export_pdf">
                <el-button class="buttons_btn" @click="expertSelectAll(1)" v-if="is_cancle">全选</el-button>
                <el-button class="buttons_btn" type="danger" @click="expertSelectAll(0)" v-if="!is_cancle">取消</el-button>
                <el-button class="buttons_btn" style="width: auto;" type="primary" @click="startExport" v-if="export_excel">确定导出报表</el-button>
                <el-button class="buttons_btn" style="width: auto;" type="primary" @click="startExport" v-if="export_pdf">确定导出资料</el-button>
                <el-button class="buttons_btn" type="primary" @click="startExport">确定导出</el-button>
                <el-button class="buttons_btn" type="danger" @click="cancelExport">取消导出</el-button>

            </div>
        </div>

        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">姓名：</span>
                <el-input v-model="user_name" placeholder="姓名模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">单位：</span>
<!--                <el-input v-model="hospital" placeholder="单位模糊搜索"/>-->
                <el-select
                    filterable
                    allow-create
                    clearable
                    v-model="hospital" placeholder="请选择状态" style="width: 100%; max-width: none !important;">
                    <el-option
                        v-for="item in hospitals"
                        :key="item.id"
                        :label="item.hospital_nick_name"
                        :value="item.hospital_nick_name"
                    ></el-option>
                </el-select>

            </el-col>
            <el-col :md="6" :lg="4" :xl="4"  :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">科室：</span>
<!--                <el-input v-model="hospital_department" placeholder="科室模糊搜索"/>-->
                <el-select
                    filterable
                    clearable
                    allow-create
                    v-model="hospital_department" placeholder="请选择状态" style="width: 100%; max-width: none !important;">
                    <el-option
                        v-for="item in departments"
                        :key="item.id"
                        :label="item.department_name"
                        :value="item.department_name"
                    ></el-option>
                </el-select>
            </el-col>
        </el-row>
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">职称：</span>
<!--                <el-input v-model="doctor_title" placeholder="职称模糊搜索"/>-->
                <el-select
                    filterable
                    allow-create
                    clearable
                    v-model="doctor_title" placeholder="请选择状态" style="width: 100%; max-width: none !important;">
                    <el-option
                        v-for="item in titles"
                        :key="item.id"
                        :label="item.title_name"
                        :value="item.title_name"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="6" :lg="4" :xl="4"  :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">状态：</span>
                <el-select
                    clearable
                    v-model="is_max_client" placeholder="请选择状态" style="width: 100%; max-width: none !important;">
                    <el-option
                        v-for="item in allStatus"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="6" :lg="4" :xl="4"  :sm="12" :xs="24">
                <el-button @click="resetForm">重置</el-button>
                <el-button @click="search">筛选</el-button>
            </el-col>
        </el-row>
        <div style="display: flex; flex-wrap: wrap">
            <el-col class="expertCard_wrap" :md="6" :lg="4" :xl="4" :sm="8" :xs="12" v-for="item in tableData" :key="item.use_id">
                <div class="expertCard">
                    <label class="el-checkbox expert_checkbox" @change="CheckExpert($event, item, 1)" v-if="(export_pdf || export_excel) && (expert_ids.indexOf(item.user_id) < 0 || is_cancle)">
                        <span class="el-checkbox__input">
                            <span class="el-checkbox__inner"></span>
                            <input type="checkbox" aria-hidden="false" class="el-checkbox__original" value="">
                        </span><!---->
                    </label>
                    <label class="el-checkbox expert_checkbox is-checked" @change="CheckExpert($event, item, 0)"  v-if="(export_pdf || export_excel) && (expert_ids.indexOf(item.user_id) > -1 || !is_cancle)">
                        <span class="el-checkbox__input is-checked">
                            <span class="el-checkbox__inner"></span>
                            <input type="checkbox" aria-hidden="false" class="el-checkbox__original" value="">
                        </span><!---->
                    </label>
                    <div class="expertCardBox" @click="goDetails(item)">
                        <el-avatar
                            :size="150"
                            v-if="item.user_avatar"
                            :src="item.user_avatar"
                            class="m-b-15"
                        >
                        </el-avatar>
                        <el-avatar
                            :size="150"
                            v-else
                            :src="require('@/assets/user_null.png')"
                            class="m-b-15"
                        >
                        </el-avatar>
                        <div class="m-b-10">
                            <span>{{ item.user_name }}</span>
                            <span class="m-l-10">{{ item.doctor_title }}</span>
                        </div>
                        <div class="m-b-10">
                            <span>{{ item.hospital_department }}</span>
                        </div>
                        <div class="m-b-10" v-if="item.group_name">
                            <span>（{{ item.group_name }}）</span>
                        </div>
                        <div class="m-b-10">
                            <span>{{ item.hospital }}</span>
                        </div>
                        <div class="m-b-10">
                            <span>&nbsp;&nbsp;&nbsp;&nbsp;{{item.totalnum + "/" + item.max_client }}</span>
                        </div>
                    </div>
                </div>
            </el-col>
        </div>

        <el-pagination
            class="mg-20 ta-r"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[12, 30, 60, 120]"
            :total="total"
            :page-size="perpage"
            :current-page="page"
            @current-change="changePage"
            @size-change="changeSite"
            v-if="is_pagination_show"
        ></el-pagination>

        <el-dialog id="expert_photo" title="专家手册" :visible.sync="dialogExpertPhotoFormVisible" @close="dialogClose">
            <el-row class="inputs mg-20">
                <el-col :md="8" :lg="8" :xl="5" :sm="12" :xs="24" style="padding-right: 10px;">
                    <span class="fs-14 pd-r-10"><span v-if="!is_mobile">&emsp;&emsp;&emsp;</span>单位：</span>
                    <el-select id="mobile-hospital" v-model="expert_hospital_name" placeholder="请选择单位" style="width: 100%;max-width: none !important;">
                        <el-option
                            v-for="item in hospitals"
                            :key="item.hospital_name"
                            :label="item.hospital_name"
                            :value="item.hospital_name"
                        ></el-option>
                    </el-select>
                </el-col>
                <el-col :md="8" :lg="8" :xl="5" :sm="12" :xs="24" style="padding-right: 10px;">
                    <span class="fs-14 pd-r-10">科室：</span>
                    <el-select id="mobile-department" v-model="expert_department_name" placeholder="请选择科室" style="width: 100%;max-width: none !important;">
                        <el-option
                            v-for="item in departments"
                            :key="item.department_name"
                            :label="item.department_name"
                            :value="item.department_name"
                        ></el-option>
                    </el-select>
                </el-col>
                <el-col :md="8" :lg="8" :xl="5" :sm="12" :xs="24" style="padding-right: 10px;">
                    <span class="fs-14 pd-r-10">职称：</span>
                    <el-select id="mobile-title" v-model="expert_title_name" placeholder="请选择科室" style="width: 100%;max-width: none !important;">
                        <el-option
                            v-for="item in titles"
                            :key="item.title_name"
                            :label="item.title_name"
                            :value="item.title_name"
                        ></el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row class="inputs mg-20">
                <el-col :md="8" :lg="8" :xl="5" :sm="12" :xs="24" style="padding-right: 10px;">
                    <span class="fs-14 pd-r-10">关键词检索：</span>
                    <el-input v-model="search_data" placeholder="专家姓名/单位/科室/职称关键词" style="padding-left: 0;"/>
                </el-col>
                <el-col :md="8" :lg="8" :xl="5" :sm="12" :xs="24" style="padding-right: 10px;">
                    <el-button class="btn-ma" @click="manualSearch">筛选</el-button>
                    <el-button class="btn-ma" @click="manualResetForm">重置</el-button>
                    <el-button class="btn-ma"type="danger" @click="manualSearch">检索到{{count_expert}}组专家体</el-button>
                </el-col>
            </el-row>
            <el-carousel ref="carousel" indicator-position="none" :autoplay="false" :arrow="carousel_arrow">
                <el-carousel-item class="image_box" v-for="page_pic in all_pictures">
                    <el-row class="inputs mg-20" :gutter="20" v-for="items in page_pic">
                        <el-col :md="4" :lg="4" :xl="3" :sm="4" :xs="6" v-for="url in items">
<!--                            <el-image class="box-image" :src="url" :preview-src-list="pictureList" @click="previewImages"></el-image>-->
                            <el-image class="box-image" :src="url" :preview-src-list="pictureList" @click="previewImages"></el-image>
                        </el-col>
                    </el-row>
                </el-carousel-item>
            </el-carousel>
        </el-dialog>
    </div>
</template>

<script>
import env from "@/api/env";
import {export2Excel} from "@/utils/excel";
import {check} from "@/utils/checkData";

import {loadFile, base64Parser, getBase64Image, authUrlCheck, isMobile} from "@/api/order"

// export word
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import {saveAs} from "file-saver";
import ImageModule from "docxtemplater-image-module-free"
import {getUserInfos} from "@/utils/userInfos";

export default {
    data() {
        return {
            role_id: 0,
            imgUrl: env.IMG_COMMON_URL_PREFIX,
            page: 1,
            perpage: 12,
            total: 0,
            tableData: [],
            is_max_client: "",
            user_name: "",
            hospital: "",
            doctor_title: "",
            hospital_department: "",
            allTitle: [],
            allHospital: [],
            allDeparment: [],
            all_expert: [],
            allStatus: [
                {
                    id: 1,
                    name: "已满",
                },
                {
                    id: 2,
                    name: "未满",
                },
            ],
            is_pagination_show: true,
            hospitals: [
                // {hospital_name: "健康一院"},
            ],
            departments: [
                // {department_name: "消化内科"},
            ],
            titles: [
                // {title_name: "副主任医师"},
            ],
            count_expert: 0,
            search_data: '',
            expert_hospital_name: '', // 筛选单位
            expert_department_name: '', // 筛选科室
            expert_title_name: '', // 筛选职称
            expert_photo: [
                // {file: "https://test.ryiw.vip/uploads/temp/2023-04-28/20230428103841733.png"},
            ],
            pictureList: [
                // "https://test.ryiw.vip/uploads/temp/2023-04-28/20230428103841733.png",
            ],
            all_pictures: [
            ],
            dialogExpertPhotoFormVisible: false,
            picture_box_height: "94%",
            clientWidth: 0,
            clientHeight: 0,
            button_position: 'static',
            is_mobile: false,
            carousel_arrow: "hover",
            expert_ids: [],
            is_cancle: 1,
            intertimer:null,
            export_pdf: 0,
            export_excel: 0,
        };
    },
    created() {
        if (isMobile()) {
            // this.button_position = 'static'
            this.is_mobile = true
            // this.carousel_arrow = 'always'
        }
        this.clientWidth = document.documentElement.clientWidth
        this.clientHeight = document.documentElement.clientHeight
    },
    mounted() {
        let prev_page = localStorage.getItem('prev_page');
        if (prev_page == 'expert_detail' || prev_page == 'expert_add') {
            this.user_name = localStorage.getItem('expert_list_user_name')
            this.doctor_title = localStorage.getItem('expert_list_doctor_title')
            this.hospital = localStorage.getItem('expert_list_hospital')
            this.hospital_department = localStorage.getItem('expert_list_hospital_department')
            this.is_max_client = localStorage.getItem('expert_list_is_max_client')
            this.page = parseInt(localStorage.getItem('page'))
            this.perpage = parseInt(localStorage.getItem('perpage'))
            if (this.user_name == 'undefined' || this.user_name == 'null') {
                this.user_name = ''
            }
            if (this.doctor_title == 'undefined' || this.doctor_title == 'null') {
                this.doctor_title = ''
            }
            if (this.hospital == 'undefined' || this.hospital == 'null') {
                this.hospital = ''
            }
            if (this.hospital_department == 'undefined' || this.hospital_department == 'null') {
                this.hospital_department = ''
            }
            if (this.is_max_client == 'undefined' || this.is_max_client == 'null') {
                this.is_max_client = ''
            }
            this.is_pagination_show = false
        }

        //获取专家列表
        this.getList();
        this.getAllHospital();
        this.getAllTitle();
        this.getAllDeparment();

        // this.getExpertInfo();
        let userInfo = getUserInfos()
        if (userInfo) {
            this.role_id = parseInt(userInfo.role_id)
        }

        // 专家手册
        this.getManual(0)

        // 手册筛选下拉选项
        this.getManualParams()

        // setTimeout(()=>{
        //     this.all_picture_redeal()
        // }, 3000)
        let devices = get_device();
        if(this.clientWidth == 980 || (devices['isTablet'] || devices['isPhone'] || devices['isAndroid']) && !devices['isPc']){

            let hospital_node = '';
            let deparatment_node = '';
            let title_node = '';
            let str1 = '';
            let str2 = '';
            let str3 = '';
            let Hindex = -1;
            let Dindex = -1;
            let Tindex = -1;
            setInterval(()=>{

                if (this.dialogExpertPhotoFormVisible === true) {
                    // document.getElementsByClassName('el-select-dropdown'):3 4 5
                    hospital_node = document.getElementById('mobile-hospital').parentNode.className
                    deparatment_node = document.getElementById('mobile-department').parentNode.className
                    title_node = document.getElementById('mobile-title').parentNode.className
                    str1 = document.getElementsByClassName('el-select-dropdown')[3].outerHTML
                    str2 = document.getElementsByClassName('el-select-dropdown')[4].outerHTML
                    str3 = document.getElementsByClassName('el-select-dropdown')[5].outerHTML

                    if (str1.indexOf('单位') > -1) {
                        Hindex = 3
                    } else if(str1.indexOf('主任') > -1) {
                        Tindex = 3
                    } else {
                        Dindex = 3
                    }

                    if (str2.indexOf('单位') > -1) {
                        Hindex = 4
                    } else if(str2.indexOf('主任') > -1) {
                        Tindex = 4
                    } else {
                        Dindex = 4
                    }

                    if (str3.indexOf('单位') > -1) {
                        Hindex = 5
                    } else if(str3.indexOf('主任') > -1) {
                        Tindex = 5
                    } else {
                        Dindex = 5
                    }

                    if (hospital_node.indexOf('is-focus') > -1) {

                        // console.log('单位',document.getElementsByClassName('el-select-dropdown')[Hindex])
                        // 展开单位下拉
                        if (Hindex > 0) {
                            document.getElementsByClassName('el-select-dropdown')[Hindex].style.left = '16.5%'
                            // alert(document.getElementsByClassName('el-select-dropdown')[Hindex].style.left)
                        }
                    }
                    if (deparatment_node.indexOf('is-focus') > -1) {
                        // console.log('科室',document.getElementsByClassName('el-select-dropdown')[Dindex])
                        // 展开单位下拉
                        document.getElementsByClassName('el-select-dropdown')[Dindex].style.left = '41%'
                        // alert(document.getElementsByClassName('el-select-dropdown')[Dindex].style.left)
                    }
                    if (title_node.indexOf('is-focus') > -1) {
                        // console.log('职称',document.getElementsByClassName('el-select-dropdown')[Tindex])
                        // 展开单位下拉
                        document.getElementsByClassName('el-select-dropdown')[Tindex].style.left = '69.5%'
                        // alert(document.getElementsByClassName('el-select-dropdown')[Tindex].style.left)
                    }

                }

            }, 10)
        }

    },
    methods: {
        exportExpertPdf() {
            this.export_pdf = true
            this.export_excel = false
        },
        exportExpertExcel() {
            this.export_pdf = false
            this.export_excel = true
        },
        startExport() {
            console.log('startExport')
            if (this.export_pdf && !this.export_excel) {
                // 导出专家资料
                this.getExpertInfo()
            } else if (!this.export_pdf && this.export_excel) {
                // 导出报表
                this.getExpertExcel()
            }
        },
        cancelExport() {
            console.log('cancelExport')
            this.export_pdf = false
            this.export_excel = false
            this.expertSelectAll(0)
        },
        CheckExpert(e, data, tag = 0) {
            if (tag) {
                // 选中
                if (this.expert_ids.indexOf(data.user_id) < 0) {
                    this.expert_ids.push(data.user_id)
                }
            } else {
                // 取消
                if (this.expert_ids.indexOf(data.user_id) > -1) {
                    this.expert_ids = this.expert_ids.filter(item => {
                    	return item != data.user_id
                    })
                }
            }
            let expertData = this.tableData
            let all_select = 1;
            for (var i = 0; i < expertData.length; i++) {
                // 检查有没有没被选中的
                if (this.expert_ids.indexOf(expertData[i].user_id) < 0) {
                    all_select = 0
                }
            }
            if(all_select) {
            	// 当前页的所有专家都被选中了
            	this.is_cancle = 0
            } else {
				this.is_cancle = 1
            }

        },
        expertSelectAll(select_all = 1) {
            let expertData = this.tableData

            for (var i = 0; i < expertData.length; i++) {
                if (select_all) {
                    // 选中
                    if (this.expert_ids.indexOf(expertData[i].user_id) < 0) {
                        this.expert_ids.push(expertData[i].user_id)
                    }
                }
            }
            if (select_all) {
                // 全选
                this.is_cancle = 0
            } else {
                // 取消全选
                this.expert_ids = []
                this.is_cancle = 1
            }
        },
        //重置表单
        resetForm() {
            this.user_name = "";
            this.doctor_title_id = "";
            this.doctor_title = "";
            this.hospital_id = "";
            this.hospital_department_id = "";
            this.hospital_department = "";
            this.hospital = "";
            this.is_max_client = "";
            this.expert_ids = []
            this.is_cancle = 1
            this.page = 1;
            this.getList();
        },

        // 搜索
        search() {
            this.page = 1;
            this.getList();
        },

        getManualParams() {
            let params = {
                servername: "Ruyi_AdminDoctorServices",
                method: "getManualSearchParams",
            };

            this.$api.service(params).then((res) => {
                if (!check(res)) {
                    return;
                }

                this.hospitals = res.data.data.hospitals
                this.departments = res.data.data.departments
                this.titles = res.data.data.titles
            });
        },
        getList() {
            let params = {
                servername: "Ruyi_AdminDoctorServices",
                method: "listing",
                params: {
                    user_name: this.user_name,
                    doctor_title: this.doctor_title,
                    hospital: this.hospital,
                    hospital_department: this.hospital_department,
                    is_max_client: this.is_max_client,
                },
                pageinfo: {
                    perpage: this.perpage,
                    page: this.page,
                },
            };

            this.$api.service(params).then((res) => {
                if (!check(res)) {
                    return;
                }
                for (var i = 0; i < res.data.data.list.length; i++) {
                    if (res.data.data.list[i].user_avatar) {
                        res.data.data.list[i].user_avatar =
                            this.imgUrl + res.data.data.list[i].user_avatar;
                    }
                }
                this.tableData = res.data.data.list;
                this.total = res.data.data.page.count;

                localStorage.setItem('expert_list_user_name', this.user_name)
                localStorage.setItem('expert_list_doctor_title', this.doctor_title)
                localStorage.setItem('expert_list_hospital', this.hospital)
                localStorage.setItem('expert_list_hospital_department', this.hospital_department)
                localStorage.setItem('expert_list_is_max_client', this.is_max_client)
                localStorage.setItem('prev_page', 'expert_list')
                localStorage.setItem('page', this.page)
                localStorage.setItem('perpage', this.perpage)
                this.is_pagination_show = true
            });
        },

        //导出
        exportList() {
            let params = {
                servername: "Minge_wallet_admin_service",
                method: "get_drawcash_list",

                params: {
                    bank_name: this.bank_name,
                    user_name: this.user_name,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    status: this.status,
                    bankcard_num: this.bankcard_num,
                },
                pageinfo: {
                    perpage: -1,
                    page: 1,
                },
            };
            this.$api.service(params).then((res) => {
                if (!check(res)) {
                    return;
                }
                let res_data = res.data;
                let export_data = [];
                if (parseInt(res_data.code) != 0) {
                    //显示错误信息，打断
                    this.$message.error(res_data.msg);
                    return false;
                }
                this.export_data = [];
                for (let i = 0; i < res_data.data.list.length; i++) {
                    let item = res_data.data.list[i];
                    item.index = i + 1;
                    item.before_amount =
                        parseInt(item.amount) + parseInt(item.after_amount);

                    item.before_amount = "￥" + (item.before_amount / 100).toFixed(2);
                    item.amount = "￥" + (item.amount / 100).toFixed(2);
                    item.after_amount = "￥" + (item.after_amount / 100).toFixed(2);

                    let status_list = ["", "未处理", "已处理"];
                    item.status_text = status_list[item.status];

                    export_data.push(item);
                }
                export2Excel(this.colums_list, export_data, "提现申请");
            });
        },

        //更换页码
        changePage(index) {
            this.page = index;
            this.getList();
        },

        changeDate(picker) {
            this.start_date = picker.displayValue[0];
            this.end_date = picker.displayValue[1];
        },

        goDetails(data) {
            if (this.role_id > 1) {
                if (!authUrlCheck('/admin/expert/ExpertDetail', this.$store.getters.authUrl)) {
                    return;
                }
            }
            this.$router.push({name: "expertDetail", query: {user_id: data.user_id}});
            return;
        }, // 改变每页条数

        changeSite(index) {
            this.perpage = index;
            this.getList();
        },

        // 获取所有单位
        getAllHospital() {
            let params = {
                servername: "Ruyi_AdminOperateServices",
                method: "getAllHospital",
            };

            this.$api.service(params).then((res) => {
                if (!check(res)) {
                    return;
                }
                this.allHospital = res.data.data;
            });
        },

        getAllDeparment() {
            let params = {
                servername: "Ruyi_AdminOperateServices",
                method: "getAllDeparment",
                params: {
                    hospital_id: this.hospital_id,
                },
            };

            this.$api.service(params).then((res) => {
                if (!check(res)) {
                    return;
                }
                this.allDeparment = res.data.data;
            });
        },

        getAllTitle() {
            let params = {
                servername: "Ruyi_AdminOperateServices",
                method: "getAllTitle",
            };

            this.$api.service(params).then((res) => {
                if (!check(res)) {
                    return;
                }
                this.allTitle = res.data.data;
            });
        },


        //新增专家
        addExpert() {
            if (this.role_id > 1) {
                if (!authUrlCheck('/admin/expert/ExpertAdd', this.$store.getters.authUrl)) {
                    return;
                }
            }
            this.$router.push({name: "expertAdd", params: {}}).catch(() => {
            });
            return;
        },
        getExpertVisits() {
            if (this.role_id > 1) {
                if (!authUrlCheck('/admin/expert/ExpertVisits', this.$store.getters.authUrl)) {
                    return;
                }
            }
            this.$router.push({name: "expertVisits", params: {}}).catch(() => {
            });
            return;
        },
        // 编辑专家自动生成手册图片
        // // 编辑专家手册
        // editExpertManual() {
        //     if (this.role_id > 1) {
        //         if (!authUrlCheck('/admin/expert/ExpertManual', this.$store.getters.authUrl)) {
        //             return;
        //         }
        //     }
        //     this.$router.push({name: "expertManual", params: {}}).catch(() => {
        //     });
        //     return;
        // },

        exportExcel() {
            let params = {
                servername: "Ruyi_AdminDoctorServices",
                method: "export",
                params: {
                    user_name: this.user_name,
                    doctor_title: this.doctor_title,
                    hospital: this.hospital,
                    hospital_department: this.hospital_department,
                    is_max_client: this.is_max_client,
                },
            };
            let colums_list = [
                {title: "专家姓名", key: "user_name"},
                {title: "职称", key: "title_name"},
                {title: "单位", key: "hospital_name"},
                {title: "科室", key: "department_name"},
                {title: "简介", key: "introduction"},
                {title: "已签约人数", key: "totalnum"},
                {title: "可签约人数", key: "client_num"},
            ];

            let export_data = [];
            this.$api.service(params).then((res) => {
                if (!check(res)) {
                    return;
                }

                let res_data = res.data;
                if (parseInt(res_data.code) != 0) {
                    this.$message.error(res_data.msg);
                    return false;
                }

                for (let i = 0; i < res_data.data.length; i++) {
                    let item = {
                        user_name: res_data.data[i].user_name,
                        title_name: res_data.data[i].title_name,
                        hospital_name: res_data.data[i].hospital_name,
                        department_name: res_data.data[i].department_name,
                        introduction: res_data.data[i].introduction,
                        totalnum: res_data.data[i].totalnum,
                        client_num: res_data.data[i].max_client,
                    };
                    export_data.push(item);
                }
                export2Excel(colums_list, export_data, "导出专家");
            });
        },


        // 获取专家导出资料
        getExpertInfo() {
            const loading = this.$loading({
                lock: true,
                text: '正在生成资料文件...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let params = {
                servername: 'Ruyi_AdminDoctorServices',
                method: 'exportDoctor',
                params: {
                    user_name: this.user_name,
                    doctor_title: this.doctor_title,
                    hospital: this.hospital,
                    hospital_department: this.hospital_department,
                    is_max_client: this.is_max_client,
                    expert_ids: this.expert_ids
                },
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                loading.close()
                this.all_expert = res.data.data

                this.$confirm(`<b style="font-size: 16px;">专家资料已成功生成pdf文件, 是否确定下载</b><br />下载链接：<a id="ExpertInfo" style="color: #0057fb;" href="${env.IMG_COMMON_URL_PREFIX+ res.data.data.download_file}" download="${res.data.data.file_name}">${env.IMG_COMMON_URL_PREFIX+ res.data.data.download_file}</a>`, '', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定下载',
                    cancelButtonText: '取消',
                }).then(() => {
                    this.downloadPdf(env.IMG_COMMON_URL_PREFIX+ res.data.data.download_file, res.data.data.file_name,"ExpertInfo")
                }).catch(()=>{});

                // this.importWord(res.data.data)
            });
        },
        getExpertExcel() {
            const loading = this.$loading({
                lock: true,
                text: '正在生成报表...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let params = {
                servername: 'Ruyi_AdminDoctorServices',
                method: 'exportDoctorExcel',
                params: {
                    user_name: this.user_name,
                    doctor_title: this.doctor_title,
                    hospital: this.hospital,
                    hospital_department: this.hospital_department,
                    is_max_client: this.is_max_client,
                    expert_ids: this.expert_ids
                },
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                loading.close()
                this.all_expert = res.data.data

                this.$confirm(`<b style="font-size: 16px;">专家资料报表文件已生成成功, 是否确定下载</b><br />下载链接：<a id="ExpertExcel" style="color: #0057fb;" href="${env.IMG_COMMON_URL_PREFIX+ res.data.data.download_file}" download="${res.data.data.file_name}">${env.IMG_COMMON_URL_PREFIX+ res.data.data.download_file}</a>`, '', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定下载',
                    cancelButtonText: '取消',
                }).then(() => {
                    this.downloadPdf(env.IMG_COMMON_URL_PREFIX+ res.data.data.download_file, res.data.data.file_name, "ExpertExcel")

                }).catch(()=>{});

                // this.importWord(res.data.data)
            });
        },
        downloadPdf(url, fileName, id=''){
            if (typeof plus !== "undefined" && id) {
                let aTarget = document.getElementById(id);
                aTarget.click()
                return;
            }
            var x = new XMLHttpRequest();
            x.open("GET", url, true);
            x.responseType = 'blob';
            x.onload=function(e) {
                var url = window.URL.createObjectURL(x.response)
                var a = document.createElement('a');
                a.href = url
                a.download = fileName;
                a.click()
            }
            x.send();

        },
        // 专家资料导出到word
        async importWord(data) {
            let newDataArr = [];

            let len = data.length;
            let manager1 = '';
            let manager2 = '';
            for (let i = 0; i < len; i++) {
                manager1 = data[i].asissant[0] ? `${data[i].asissant[0].name}(${data[i].asissant[0].mobile})` : '暂无';
                manager2 = data[i].asissant[1] ? `${data[i].asissant[1].name}(${data[i].asissant[1].mobile})` : '';

                newDataArr.push({
                    "name": data[i].user_name,
                    "doctor_title": data[i].doctor_title,
                    "hospital": data[i].hospital,
                    "hospital_department": data[i].hospital_department,
                    "strengths": data[i].strengths,
                    "introduction": data[i].introduction,
                    "avatar": await getBase64Image(env.IMG_COMMON_URL_PREFIX + data[i].user_avatar),
                    "degree": data[i].degree,
                    "working_year": data[i].working_year,
                    "mobile": data[i].mobile,
                    "mname1": manager1,
                    "mname2": manager2,

                })
            }

            loadFile(
                "doctor-info.docx",
                function (error, content) {

                    if (error) {
                        throw error;
                    }
                    const zip = new PizZip(content);

                    let imageOpts = {}
                    imageOpts.centered = true;  // 图片居中，在word模板中定义方式为{%%image}
                    imageOpts.fileType = "docx";
                    imageOpts.getImage = function (newImgUrl) {
                        return base64Parser(newImgUrl);
                    }
                    imageOpts.getSize = function () {
                        return [140, 140]
                    }

                    const doc = new Docxtemplater(zip, {
                        paragraphLoop: true,
                        linebreaks: true,
                        modules: [new ImageModule(imageOpts)],
                    });

                    doc.render({
                        "doctor": newDataArr
                    });

                    const out = doc.getZip().generate({
                        type: "blob",
                        mimeType:
                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    });
                    // Output the document using Data-URI
                    saveAs(out, "专家资料.docx");

                }
            );

        },
        // 专家手册
        oneReservationDetail(data) {
            document.querySelector('body').classList.add('el-popup-parent--hidden')
            // this.dialogExpertPhotoFormVisible = true;
            // return;
            this.all_pictures = [];
            let all_pictures = [];
            let url = null;
            if (data.photo_pictures) {
                let photo_pictures = JSON.parse(data.photo_pictures);
                if (photo_pictures.length > 0) {
                    for (let i = 0; i < photo_pictures.length; i++) {
                        if (photo_pictures[i].file.indexOf("http") < 0) {
                            url = this.imgUrl + photo_pictures[i].file;
                        } else {
                            url = photo_pictures[i].file;
                        }
                        all_pictures.push(url);
                    }
                }
            }

            this.all_pictures = all_pictures;
            this.dialogExpertPhotoFormVisible = true;

            this.all_picture_redeal()
            setTimeout(()=>{
                this.slideBanner()
            }, 1000)
        },
        dialogClose() {
            this.dialogExpertPhotoFormVisible = false
            // 关闭弹窗的时候，移除类名
            document.querySelector('body').classList.remove('el-popup-parent--hidden')
            this.manualResetForm()
            clearInterval(this.intertimer)
        },
        getManual(is_search = 0) {
            this.count_expert = 0
            let params = {
                servername: "Ruyi_AdminDoctorServices",
                method: "getManual",
                params: {
                    search_data: this.search_data,
                    expert_hospital_name: this.expert_hospital_name,
                    expert_department_name: this.expert_department_name,
                    expert_title_name: this.expert_title_name,
                },
            };

            this.$api.service(params).then((res) => {
                if (!check(res)) {
                    return;
                }
                let url = '';
                if (res.data.data) {
                    for (var i = 0; i < res.data.data.length; i++) {
                        url = this.imgUrl + res.data.data[i].manaul
                        this.expert_photo.push({
                            file: url
                        })
                        this.pictureList.push(url)
                        this.all_pictures.push(url)
                    }
                    this.count_expert = res.data.data.length
                    if (is_search) {
                        this.all_picture_redeal()
                    }
                } else {
                    this.count_expert = 0
                }


            });
        },
        // 分页处理all_picture
        all_picture_redeal() {
            let is_pc = get_device()['isPc'];
            // let flg_num = is_pc ? 2 : 3;
            let flg_num = (this.clientHeight > this.clientWidth) ? 2 : 3;
            if (this.clientHeight == 544) {
                flg_num = 2
            }
            if ((this.clientHeight / this.clientWidth) > 1.4) {
                flg_num = 6
            } else if ((this.clientHeight / this.clientWidth) > 1.3) {
                flg_num = 4
            }
            let line_number = this.clientWidth >= 768 ? 6 : 4;
            if (this.clientWidth >= 1920) {
                line_number = 8
            }
            let pic_arr = [];
            let old_all_picture = this.all_pictures
            let res_arr = [];
            for (let i = 0; i < old_all_picture.length; i++) {
                if (i%line_number) {
                    pic_arr.push(old_all_picture[i])
                } else {
                    if (pic_arr.length > 0) {
                        res_arr.push(pic_arr)
                    }
                    pic_arr = []
                    pic_arr.push(old_all_picture[i])
                }
            }
            if (pic_arr.length > 0) {
                res_arr.push(pic_arr)
            }
            let last_arr = [];
            let last_res = [];
            for (let i = 0; i < res_arr.length; i++) {
                if (i%flg_num) {
                    last_arr.push(res_arr[i])
                } else {
                    if (last_arr.length > 0) {
                        last_res.push(last_arr)
                    }
                    last_arr = []
                    last_arr.push(res_arr[i])
                }
            }
            if (last_arr.length > 0) {
                last_res.push(last_arr)
            }
            this.all_pictures = [];
            this.all_pictures = last_res
        },
        //重置表单
        manualResetForm() {
            this.expert_photo = []
            this.pictureList = []
            this.all_pictures = []
            this.search_data = '';
            this.expert_hospital_name = '';
            this.expert_department_name = '';
            this.expert_title_name = '';
            this.getManual(1);
        },

        // 搜索
        manualSearch() {
            this.expert_photo = []
            this.pictureList = []
            this.all_pictures = []
            this.getManual(1);
        },
        slideBanner() {
            let that = this
            //选中item的盒子
            var box = document.querySelector('.el-carousel__container')
            //手指起点X坐标
            var startPoint = 0
            //手指滑动重点X坐标
            var stopPoint = 0

            //重置坐标
            var resetPoint = function () {
                startPoint = 0
                stopPoint = 0
            }

            //手指按下
            box.addEventListener('touchstart', function (e) {
                //手指按下的时候停止自动轮播
                //手指点击位置的X坐标
                startPoint = e.changedTouches[0].pageX

            })
            //手指滑动
            box.addEventListener('touchmove', function (e) {
                //手指滑动后终点位置X的坐标
                stopPoint = e.changedTouches[0].pageX
            })
            //当手指抬起的时候，判断图片滚动离左右的距离
            box.addEventListener('touchend', function () {

                if (stopPoint == 0 || startPoint - stopPoint == 0) {
                    // resetPoint()
                    return true
                }
                if (startPoint - stopPoint > 0) {
                    resetPoint()
                    that.$refs.carousel.next()
                    return
                }
                if (startPoint - stopPoint < 0) {
                    resetPoint()
                    that.$refs.carousel.prev()
                    return
                }
            })

        },
        previewImages() {
            let that = this
            let pictureList = this.pictureList
            clearInterval(this.intertimer)
            this.intertimer = setInterval(()=>{
                //选中item的盒子
                let box = document.querySelector('.el-image-viewer__wrapper')
                let imgView = document.querySelector('.el-image-viewer__img')
                imgView.classList = 'el-image-viewer__img mui-zoom'
                let imgViewStyle = null;
                //手指起点X坐标
                let startPointX = 0
                let startPointY = 0
                //手指滑动重点X坐标
                let stopPointX = 0
                let stopPointY = 0
                let firstDistance  = 0;
                let distance = 0;
                let zoom  = 1;
                let is_scale = 0;

                //重置坐标
                let resetPoint = function () {
                    startPointX = 0
                    stopPointX = 0
                    // startPointX = e.changedTouches[0].pageX
                    // startPointY = e.changedTouches[0].pageY
                }

                let getDistance =  (start, stop) => { //计算两根手指之间的距离
                    return Math.sqrt(Math.pow(Math.abs(start.x - stop.x), 2) + Math.pow(Math.abs(start.y - stop.y), 2));
                }

                // console.log(box)
                //手指按下
                box.addEventListener('touchstart', function (e) {

                    if (e.touches.length > 1) {
                        // 双指缩放
                        is_scale = 1
                        const one = {
                            x:e.touches[0].pageX, //第一根手指的横坐标
                            y:e.touches[0].pageY, //第一根手指的纵坐标
                        }; //第一根手指的横坐标
                        const two = {
                            x:e.touches[1].pageX, //第二根手指的横坐标
                            y:e.touches[1].pageY, //第二根手指的纵坐标
                        };

                        firstDistance = getDistance(one,two);

                    } else {
                        is_scale = 0
                        // 单指移动
                        //手指点击位置的X坐标
                        startPointX = e.changedTouches[0].pageX
                        startPointY = e.changedTouches[0].pageY
                    }


                })

                //手指滑动
                box.addEventListener('touchmove', function (e) {
                    imgViewStyle = getComputedStyle(imgView)

                    //手指滑动后终点位置X的坐标
                    stopPointX = e.changedTouches[0].pageX
                    stopPointY = e.changedTouches[0].pageY

                    if (is_scale || e.touches.length > 1) {
                        //双指缩放事件
                        const one = {
                            x:e.touches[0].pageX, //第一根手指的横坐标
                            y:e.touches[0].pageY, //第一根手指的纵坐标
                        }; //第一根手指的横坐标
                        const two = {
                            x:e.touches[1].pageX, //第二根手指的横坐标
                            y:e.touches[1].pageY, //第二根手指的纵坐标
                        };
                        distance = getDistance(one,two);
                        zoom = distance / firstDistance
                        // alert(`zoom:${zoom},distance:${distance},firstDistance:${firstDistance}`)
                        imgView.style.transform = 'scale('+ zoom +')';
                        // is_scale = 0
                        return;
                    } else {
                        if (!startPointX || !startPointY) return;
                        if (startPointX - stopPointX > 0) {
                            // 左移
                            imgView.style.marginLeft = (parseFloat(imgViewStyle.marginLeft) - (startPointX - stopPointX)).toString() + 'px'
                        }
                        if (startPointX - stopPointX < 0) {
                            // 右移
                            imgView.style.marginLeft = (parseFloat(imgViewStyle.marginLeft) + (stopPointX - startPointX)).toString() + 'px'
                        }
                        if (startPointY - stopPointY > 0) {
                            // 上移
                            imgView.style.marginTop = (parseFloat(imgViewStyle.marginTop) - (startPointY - stopPointY)).toString() + 'px'

                        }
                        if (startPointY - stopPointY < 0) {
                            // 下移
                            imgView.style.marginTop = (parseFloat(imgViewStyle.marginTop) + (stopPointY - startPointY)).toString() + 'px'
                        }
                        startPointX = e.changedTouches[0].pageX
                        startPointY = e.changedTouches[0].pageY
                    }

                    is_scale = 0
                })
                //当手指抬起的时候，判断图片滚动离左右的距离
                box.addEventListener('touchend', function () {
                    is_scale = 0
                    resetPoint()
                })
            },1000)

        },
    },
};

function get_device() {
    let ua = navigator.userAgent,
        isWindowsPhone = /(?:Windows Phone)/.test(ua),
        isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
        isAndroid = /(?:Android)/.test(ua),
        isFireFox = /(?:Firefox)/.test(ua),
        isChrome = /(?:Chrome|CriOS)/.test(ua),
        isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox &&
            /(?:Tablet)/.test(ua)),
        isPhone = /(?:iPhone)/.test(ua) && !isTablet,
        isPc = !isPhone && !isAndroid && !isSymbian;
    return {
        isTablet: isTablet,
        isPhone: isPhone,
        isAndroid: isAndroid,
        isPc: isPc
    };
}
</script>

<style lang="scss">
@import "@/styles/common.scss";

.docker_buttons {
    width: 100%;
    float: right;
    margin: 30px 0px 8px 0px;

    .el-button {
        width: 150px;
        height: 32px;
        line-height: 7px;
        float: right;
    }
}

.inputs .el-input {
    width: 100% !important;
}

.LongCard {
    padding: 0px 0px 0px 0px;
    background: #ffffff;
    position: relative;
    display: flex;

    .sign {
        position: absolute;
        top: 15px;
        right: 20px;
    }

    .info {
        flex: 1;
        margin-left: 50px;
        text-align: left;

        & > div {
            margin-bottom: 15px;
        }

        & > div:last-child {
            margin-bottom: 0px;
        }

        .name {
            font-size: 18px;
            margin-right: 20px;
        }

        .hospital {
            font-size: 16px;
            margin-right: 20px;
        }

        .des {
            font-size: 14px;
            color: #808080;
            line-height: 23px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 5;
            overflow: hidden;
        }
    }
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both;
}

.expertCard_wrap {
    //width: 20%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .expertCard {
        width: 75%;
        border: 1px solid #f4f4f4;
        padding: 20px;
        margin-bottom: 15px;
        position: relative;
        .m-b-15 {
            margin-bottom: 15px;
        }

        .m-b-10 {
            margin-bottom: 10px;
        }

        .m-l-10 {
            margin-left: 10px;
        }
        .expert_checkbox {
            height: 14px;
            position: absolute;
            left: 0;
            top: 0;
            .el-checkbox__inner{
                width: 14px;border: 1px solid #bdbdbd;
                transform: translateY(-1px);
            }
        }
    }
}

#expert_photo > .el-dialog {
    width: 90%;
    min-width: auto;
    margin-top: 2vh !important;
    height: 96vh !important;

    .el-dialog__body {
        height: 92.5%;
        padding: 0 20px 10px !important;

        .el-carousel.el-carousel--horizontal {
            height: calc(100% - 104px);

            .el-carousel__container {
                height: 100% !important;

                .el-image {
                    height: 100%;

                    img {
                        max-height: 100%;
                        width: auto;
                        max-width: 100%;
                        height: auto;
                    }
                }
            }
        }
    }

}
.buttons_btn{
    margin-top: 5px;
}

.expert-list {
    .el-dialog__wrapper {
        overflow: hidden;
    }

    .el-dialog__body {
        padding: 10px 20px;
    }
}

.el-image-viewer__wrapper {
    z-index: 3000 !important;
}

.el-popup-parent--hidden {
    overflow: hidden;
}

.inputs .el-select {
    max-width: none !important;
}
.image_box {
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
}
.el-avatar>img{
    width: 100% !important;
}
.el-col{
    margin-bottom: 10px;
    input{
        width: 100%;
    }
}
.btn-ma{
    padding-left: 10px !important;
    padding-right: 10px !important;
}
.el-loading-spinner .el-loading-text,.el-loading-spinner i{
    color: #ffc3c3;
}
</style>

